import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container footer-container">
        <p>&copy; {currentYear} SpitFire. All rights reserved.</p>

        <div className="powered-by">
          <span>Powered by{' '}
            <a
              href="https://www.cloudcafe.co.za"
              target="_blank"
              rel="noopener noreferrer"
            >
              CloudCafe
            </a>
          </span>
        </div>

        {/* CloudCafe Portfolio — sister sites cross-link for SEO */}
        <div>
          <small style={{ color: '#999' }}>
            Also by{' '}
            <a href="https://www.cloudcafe.co.za" target="_blank" rel="noopener noreferrer" style={{ color: '#D4752E' }}>
              CloudCafe
            </a>
            {' | '}
            <a href="https://www.ddconstruction.co.za" target="_blank" rel="noopener noreferrer" style={{ color: '#D4752E' }}>
              DD Construction
            </a>
          </small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;